import { __rest } from "tslib";
import React from 'react';
import { AlertWarning } from '../Alert';
import Collapse from './Collapse';
import { string } from 'prop-types';
import clsx from 'clsx';
import './FieldError.less';
export default function FieldError(props) {
    const { error, className } = props, otherProps = __rest(props, ["error", "className"]);
    return (React.createElement(Collapse, Object.assign({ isExpanded: Boolean(error), className: clsx('kal-field-error', className) }, otherProps),
        React.createElement(AlertWarning, { inline: true }, error)));
}
FieldError.propTypes = {
    error: string,
    className: string,
};
//# sourceMappingURL=FieldError.js.map